import React from 'react';
import PropTypes from 'prop-types';
import {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonList,
    IonItem,
    IonLabel,
    IonText,
    IonInput,
    IonRow,
    IonCol,
    IonImg,
    IonItemDivider,
    IonProgressBar,
    IonToast,
    IonCheckbox,
    IonGrid,
    IonIcon
  } from '@ionic/react';
import { connect } from 'react-redux'
import './Login.css';
import { eyeOutline, eyeOffOutline } from 'ionicons/icons';

import loginActions from '../actions/login'
import ErrorAlert from '../components/ErrorAlert'

interface IProps {
  auth: any;
  changeFields: any;
}

interface IState {
  data: any;
  check: boolean;
  eye: boolean;
}

class Login extends React.Component<IProps, IState> {
    constructor(props: any) {
    super(props)
    this.state = {data: props.data, check: false, eye: true}
  }

  componentDidMount(){
    if (window.localStorage.getItem('password_codesii')) {
      this.setState({ check: true });
      let fields = this.state.data.fields;
      fields["email"] = window.localStorage.getItem('email_codesii');
      fields["password"] = window.localStorage.getItem('password_codesii');
      this.props.changeFields(fields)
    }else{
      this.setState({ check: false });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  send(){
    this.props.auth({email: this.state.data.fields.email, password: this.state.data.fields.password, check: this.state.check}, "login")
  }

  handleChange(event: any) {
    let fields = this.state.data.fields;
    fields[event.target.name] = event.target.value;
    this.props.changeFields(fields)
  }

  handleChangeCheckBox(event: any) {
    this.setState({ check: !this.state.check });
  }

  showPassword(){
    this.setState({ eye: !this.state.eye });
  }

  render() {
    const { formErrors, simpleToast, toastMessage } = this.state.data;
    const { check, eye } = this.state
    return (
      <IonPage>
        <ErrorAlert/>
        <IonContent fullscreen>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle size="large">Login</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonProgressBar style={ this.state.data.loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
          <IonToast
            isOpen={simpleToast}
            buttons={[
              {
                text: 'Ok',
                role: 'cancel'
              }
            ]}
            message={`${toastMessage}`}
            duration={3000}
          />
          <IonRow class="ion-padding-top">
            <IonCol className="ion-align-self-start" size="2"></IonCol>
            <IonCol className="ion-align-self-center">
              <IonImg src="assets/img/logoedusolucion.jpg"/>
            </IonCol>
            <IonCol className="ion-align-self-end" size="2"></IonCol>
          </IonRow>

          <IonRow>
            <IonCol className="ion-align-self-start"></IonCol>
            <IonCol className="ion-align-self-center">
              <IonText color="primary">
                <h1>Autenticación</h1>
              </IonText>
            </IonCol>
            <IonCol className="ion-align-self-end"></IonCol>
          </IonRow>

          <IonRow>
            <IonCol className="ion-align-self-start" size="1"></IonCol>
            <IonCol className="ion-align-self-center">
              Para ingresar debe proporcionar la siguiente información.
            </IonCol>
            <IonCol className="ion-align-self-end" size="1"></IonCol>
          </IonRow>

          <IonItemDivider></IonItemDivider>
          <form>
            <IonList lines="full" className="ion-no-margin ion-no-padding">
              <IonItem>
                <IonLabel position="stacked">Correo electrónico: <IonText color="danger">*</IonText></IonLabel>
                <IonInput name="email" required type="email" onIonChange={this.handleChange.bind(this)} value={this.state.data.fields.email || "" }></IonInput>
              </IonItem>
              {formErrors.errors && formErrors.errors.email && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.email}</small>
                </IonText>
              )}

              <IonItem>
                <IonLabel position="stacked">Contraseña: <IonText color="danger">*</IonText></IonLabel>
                <IonInput name="password" required type={eye ? "password" : "text"} onIonChange={this.handleChange.bind(this)} value={this.state.data.fields.password || "" }></IonInput>
                <IonIcon icon={eye ? eyeOffOutline : eyeOutline} slot="end" onClick={this.showPassword.bind(this)}></IonIcon>
              </IonItem>
              {formErrors.errors && formErrors.errors.password && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.password}</small>
                </IonText>
              )}

              <div style={{ paddingLeft: '5%', paddingTop: '5%' }}>
                <IonCheckbox checked={check} onIonChange={this.handleChangeCheckBox.bind(this)}></IonCheckbox>&nbsp;&nbsp;&nbsp;
                <IonLabel position="stacked">Recordar contraseña</IonLabel>
              </div>
            </IonList>

            <div className="ion-padding">
              <IonButton expand="block" className="ion-no-margin" onClick={this.send.bind(this)}>Ingresar</IonButton>
            </div>
          </form>

        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    auth: PropTypes.func.isRequired,
    data: state.data,
    changeFields: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    auth: (fields: any, typeOptions: string) => dispatch(loginActions.auth(fields, typeOptions)),
    changeFields: (fields: any) => dispatch(loginActions.changeFields(fields))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
